/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import { FormattedNumber } from 'react-intl';
import numeral from 'numeral';
import { Link } from 'react-router-dom';

class ImportHints extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAll: {
                twitter: false,
                facebook: false,
                instagramUsers: false,
                instagramTags: false,
                feeds: false
            }
        };

        this.onShowMore = this.onShowMore.bind(this);
        this.generateResultsBlock = this.generateResultsBlock.bind(this);

    }

    onShowMore(e) {

        e.preventDefault();

        let showAll = this.state.showAll,
            service = e.currentTarget.dataset.service,
            type = e.currentTarget.dataset.resulttype;

        if (type !== undefined) {
            if (service === "instagram") {
                if (type === "Accounts") {
                    showAll.instagramUsers = ~showAll.instagramUsers;
                } else if (type === "Tags") {
                    showAll.instagramTags = ~showAll.instagramTags;
                }
            } else {
                showAll[service] = ~showAll[service];
            }
        } else if (showAll[service] !== undefined) {
            showAll[service] = ~showAll[service];
        }

        this.setState({
            showAll
        });

    }

    generateResultsBlock(hints, service, error) {

        let constants = this.props.app.config.constants,
            serviceData = {
                'twitter' : {
                    name: 'Twitter',
                    icon: (<IconFactory.twitter white={true} bare={true} alt={"mid"}/>),
                    resultTypes: ['Accounts'],
                    svcID: constants.BULK_SVC_TWITTER
                },
                // 'instagram' : {
                //     name: 'Instagram',
                //     icon: <IconFactory.instagram white={true} bare={true} alt={"mid"} />,
                //     resultTypes: ['Accounts', 'Tags'],
                //     svcID: constants.BULK_SVC_INSTAGRAM
                // },
                'feeds' : {
                    name: 'Feeds',
                    icon: <IconFactory.feed white={true} bare={true} alt={"mid"} />,
                    resultTypes: ['Sources'],
                    svcID: constants.BULK_SVC_FEED
                }
            },
            accordionLabel = 'see more >>',
            errorBlock = null;

        if (this.state.showAll[service]) {
            accordionLabel = '<< see less';
        }

        if (error) {
            if (error.match("No active")) {
                if (service === "instagram") {
                    errorBlock = (
                        <div className="import-add-service">
                            <Link to="/share/automate/new/inputs" className="import-add-social">Add an Instagram</Link> feed and find even more content for your EverQueues.
                        </div>
                    );
                } else if (service === "twitter") {
                    errorBlock = (
                        <div className="import-add-service">
                            <a href="#" onClick={this.props.onAddSocial} className="import-add-social">Connect</a> a <span className="import-service">{service}</span> profile to enable Twitter search.
                        </div>
                    );
                } else if (service === "facebook") {
                    errorBlock = (
                        <div className="import-add-service">
                            <a href="#" onClick={this.props.onAddSocial} className="import-add-social">Connect</a> a <span className="import-service">{service}</span> profile or page to enable Facebook search.
                        </div>
                    );
                }
            } else {
                errorBlock = (
                    <span><i className="ion-alert"></i><Link to="/config/socials">Reconnect</Link> {serviceData[service].name} to enable {serviceData[service].name} search.</span>
                );
            }
            return (
                <div className={"import-hints-block " + service}>
                    <div className="import-hints-header">
                        {serviceData[service].icon}
                        <span className="import-header-label">{serviceData[service].name}</span>
                    </div>
                    <div className="import-hints-error">
                        {errorBlock}
                    </div>
                </div>
            )
        }

        return (
            <div className={"import-hints-block " + service}>
                <div className="import-hints-header">
                    {serviceData[service].icon}
                    <span className="import-header-label">{serviceData[service].name}</span>
                </div>
                {serviceData[service].resultTypes.map((type, i) => {
                    let hintList = hints[i],
                        hintOutput = null;

                    // skip instagram for now
                    if (serviceData[service].svcID == constants.BULK_SVC_INSTAGRAM) {
                        return null;
                    }

                    if (hintList.length) {
                        hintOutput = hintList.map((hint, i) => {
                            let social = {
                                    psID: serviceData[service].svcID
                                },
                                label = '',
                                stats = '',
                                id = null,
                                followers = '',
                                posts = '',
                                geo = '';

                            if (hint.id) {
                                id = social.psID + "-" + hint.id;
                            } else {
                                id = social.psID + "-" + i;
                            }

                            switch (social.psID) {
                                case constants.BULK_SVC_TWITTER:
                                case constants.BULK_SVC_INSTAGRAM:
                                    if (type === "Tags") {
                                        social.name = hint.tag;
                                        label = "#" + hint.tag;
                                        let postCount = numeral(hint.posts).format('0[.]0a');
                                        stats = (
                                            <div className="hint-stats">
                                                {postCount} posts
                                            </div>
                                        )
                                    } else {
                                        social.name = hint.name;
                                        if (hint.icon) {
                                            social.icon = hint.icon;
                                        }
                                        label = hint.name + " (@" + hint.username + ")",
                                        geo = '';

                                        if (social.psID === constants.BULK_SVC_TWITTER) {
                                            if (hint.location) {
                                                geo = " | " + hint.location;
                                            }

                                            if (hint.follow_count !== undefined) {
                                                followers = numeral(hint.follow_count).format('0[.]0a');
                                            }
                                            if (hint.tweet_count !== undefined) {
                                                posts = numeral(hint.tweet_count).format('0[.]0a');
                                            }

                                            stats = (
                                                <div className="hint-stats">
                                                    {followers} followers | {posts} tweets {geo}
                                                </div>
                                            );
                                        }
                                    }

                                    break;

                                case constants.BULK_SVC_FEED:
                                    social.name = hint.title;
                                    if (hint.iconUrl) {
                                        social.icon = hint.iconUrl;
                                        social.icon = social.icon.replace("http:", "https:");
                                    }
                                    label = hint.title;
                                    break;
                            }

                            return (
                                <div className="import-hints-item" key={id} onClick={this.props.onClick} data-service={serviceData[service].svcID} data-resultquery={hint.result_query}>
                                    <div className="hint-avatar">
                                        <SocialAvatar social={social} compact={true}/>
                                    </div>
                                    <div className="hint-label-wrapper">
                                        <div className="hint-label">{label}</div>
                                        {stats}
                                    </div>
                                    <div className="hint-button-wrapper">
                                        <div className="hint-button" onClick={this.props.onClick} data-service={serviceData[service].svcID} data-resultquery={hint.result_query} role="button" aria-label={`see results for ${label}`}>
                                            {">>"}
                                        </div>
                                    </div>
                                </div>
                            );
                        });
                    } else {
                        hintOutput = (
                            <div className="import-hints-no-results">
                                No results
                            </div>
                        );
                    }

                    return (
                        <div key={service + "-" + type}>
                            <div className="import-hints-subheader">
                                <div className="see-more">
                                    <a href="#" onClick={this.onShowMore} data-service={service} data-resulttype={type}>{accordionLabel}</a>
                                </div>
                                <div className="type-label">
                                    {type}
                                </div>
                            </div>
                            <div className="import-hints-list">
                                {hintOutput}
                            </div>
                        </div>
                    );
                })}
            </div>
        )
    }

    render() {

        let constants = this.props.app.config.constants,
            twitterResults = null,
            facebookResults = null,
            instaResults = null,
            feedResults = null,
            hints = this.props.bulk.hints,
            list = null,
            userList = null,
            tagList = null,
            splitList = (list, service) => {
                if (typeof list.slice !== "function") {
                    // TODO: this is likely an error state, do something with it
                    return [];
                }
                if (this.state.showAll[service]) {
                    return list;
                }
                return list.slice(0, 6);
            };

        if (hints[constants.BULK_SVC_TWITTER]) {
            if (Array.isArray(hints[constants.BULK_SVC_TWITTER])) {
                list = splitList(hints[constants.BULK_SVC_TWITTER], 'twitter');
                twitterResults = this.generateResultsBlock([list], 'twitter');
            } else if (hints[constants.BULK_SVC_TWITTER].error) {
                twitterResults = this.generateResultsBlock([], 'twitter', hints[constants.BULK_SVC_TWITTER].error);
            }
        }
        if (hints[constants.BULK_SVC_INSTAGRAM]) {
            if (Array.isArray(hints[constants.BULK_SVC_INSTAGRAM]) === false) {
                // if (hints[constants.BULK_SVC_INSTAGRAM].error) {
                //     instaResults = this.generateResultsBlock([], 'instagram', hints[constants.BULK_SVC_INSTAGRAM].error);
                // } else {
                //     userList = splitList(hints[constants.BULK_SVC_INSTAGRAM].users, 'instagramUsers');
                //     tagList = splitList(hints[constants.BULK_SVC_INSTAGRAM].tags, 'instagramTags');
                //     instaResults = this.generateResultsBlock([userList, tagList], 'instagram');
                // }
            }
        }
        if (hints[constants.BULK_SVC_FEED]) {
            if (Array.isArray(hints[constants.BULK_SVC_FEED])) {
                list = splitList(hints[constants.BULK_SVC_FEED], 'feeds');
                feedResults = this.generateResultsBlock([list], 'feeds');
            } else if (hints[constants.BULK_SVC_FEED].error) {
                feedResults = this.generateResultsBlock([], 'feeds', hints[constants.BULK_SVC_FEED].error);
            }
        }


        return (
            <div className="import-hints-wrapper">
                {twitterResults}
                {facebookResults}
                {instaResults}
                {feedResults}
            </div>
        );
    }
}

ImportHints.displayName = "ImportHints";

ImportHints.propTypes = {
    hints: PropTypes.object,
    onClick: PropTypes.func
};

ImportHints.defaultProps = {
    hints: {},
    onClick: () => {}
};

export default ImportHints;
